































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {SelectOption} from "@/util/selectOption";
import axios from 'axios';
import {currency} from "@/util/formatter";
import spacetime from "spacetime";

type SubmittedReturn = {
    submittedAt: string;
    taxPaid: string;
    nicPaid: string;
    documentRef: string;
    hasRebate: boolean;
}

type InProgressReturn = {
    progress: number;
    submissionDeadline: string;
    isAfterSubmissionDeadline: boolean;
    balancingPayment: string | null;
}

type FutureReturn = {
    earliestSubmissionDate: string;
}

@Component
export default class TaxReturnPicker extends Vue {

    @Prop()
    taxYears!: number[];

    private isLoading: boolean = false;
    private isDownloadingSA302Report: boolean = false;
    private returnData: SubmittedReturn | InProgressReturn | FutureReturn | null = null;

    private yearOptions: SelectOption[] = this.taxYears.map(year => {
        return {
            name: `${year} - ${year+1}`,
            id: year
        }
    });

    private yearOption: SelectOption = this.yearOptions[0];

    private mounted() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const year = urlSearchParams.get('year');
        if (year) {
            const selectedOption = this.yearOptions.find((option) => option.id === parseInt(year));
            if (selectedOption) {
                this.yearOption = selectedOption;
            }
        }

        this.fetchData();
    }

    private get nextStepHref(): string {
        const inProgressReturn = this.returnData as InProgressReturn;
        if (inProgressReturn.progress === 100) {
            return `/tax-return/${this.yearOption.id}/review`;
        }

        return `/tax-return/${this.yearOption.id}/basic-details`;
    }

    private get actionButtonTitle(): string {
        const inProgressReturn = this.returnData as InProgressReturn;
        if (inProgressReturn.progress === 100) {
            return 'Submit';
        }

        return 'Proceed';
    }

    @Watch('yearOption')
    private onYearOptionChanged() {
        this.fetchData();
    }

    private fetchData() {
        this.isLoading = true;
        this.returnData = null;

        axios.get(`/tax-return/${this.yearOption.id}`)
            .then(result => {
                const data = result.data;
                if (data.is_submitted) {
                    const taxReturnData = data.tax_return_data;
                    this.returnData = <SubmittedReturn> {
                        submittedAt: spacetime(taxReturnData.submitted_at, 'utc').format('nice-year').toString(),
                        taxPaid: currency(taxReturnData.tax_paid),
                        nicPaid: currency(taxReturnData.nic_paid),
                        documentRef: taxReturnData.document_ref,
                        hasRebate: taxReturnData.has_rebate,
                    }
                } else if (data.earliest_submission_date) {
                    const earliestSubmissionDate = spacetime(data.earliest_submission_date, 'utc');
                    this.returnData = <FutureReturn> {
                        earliestSubmissionDate: earliestSubmissionDate.format('nice-year').toString()
                    }
                } else {
                    const submissionDeadlineDate = spacetime(data.submission_deadline, 'utc');
                    this.returnData = <InProgressReturn> {
                        progress: data.progress,
                        submissionDeadline: submissionDeadlineDate.format('nice-year').toString(),
                        isAfterSubmissionDeadline: spacetime.now('utc').isAfter(submissionDeadlineDate),
                        balancingPayment: data.balancing_payment
                    }
                }
            })
            .catch(error => {
                // TODO: Surface something to user
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            })
    }

    private downloadSA302() {
        this.isDownloadingSA302Report = true

        axios.get(`/pdf/sa302/${this.yearOption.id}`)
            .then(response => {
                const link = document.createElement('a');
                // @ts-ignore
                link.href = response.data.download;
                // @ts-ignore
                link.setAttribute('download', response.data.filename);
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                // TODO: surface the error to the user
            })
            .finally(() => {
                this.isDownloadingSA302Report = false
            })
    }
}
